import * as React from 'react';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import { Box } from '@mui/material';

const CountryDataGraph = ({ TopCountries }) => {
    if (!TopCountries || TopCountries.length === 0) {
        return <div>No country data available</div>;
    }

    const formattedData = TopCountries.map((item) => ({
        id: item.country,
        value: item.percentage,
        label: item.country,
    }));

    const size = {
        width: 400,
        height: 450,
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <PieChart
                series={[
                    {
                        arcLabel: (item) => `${item.value}%`,
                        arcLabelMinAngle: 10,
                        arcLabelRadius: '60%',
                        data: formattedData,
                    },
                ]}
                slotProps={{
                    legend: {
                        direction: 'row',
                        position: { vertical: 'bottom', horizontal: 'center' },

                    },
                }}
                sx={{
                    [`& .${pieArcLabelClasses.root}`]: {
                        fontWeight: 'bold',

                    },


                }}
                {...size}
            />
        </Box>
    );
}
export default CountryDataGraph;
